import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';

const initialState = {
  list: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  detail: { data: null, loading: false },
  instances: { data: null, loading: false },
  brand: { data: null, loading: false },
  thumb: { data: null, loading: false },
  matItemTypes: { data: [], loading: false },
  colors: { data: [], loading: false },
  configure: { data: null, loading: false },
  filters: { data: [], loading: false },
  confirm: { title: '', content: '', visible: false, loading: false },
  searchParams: null,
  loading: false,
};

export default { namespaced: true, state: initialState, actions, mutations } as IStore<IModuleState>;
